import React from 'react';
import NetworkList from '../elements/NetworkList';
import ResumeList from '../elements/ResumeList';
import ResumeJobs from '../elements/ResumeJobs';

// Menu Images
/* eslint-disable import/no-webpack-loader-syntax */
import imgAbout from '../../images/pages/menu/about.jpg';
import svgAbout from '-!raw-loader!../../images/pages/menu/about.svg';

import imgContact from '../../images/pages/menu/contact.jpg';
import svgContact from '-!raw-loader!../../images/pages/menu/contact.svg';

import imgStories from '../../images/pages/menu/stories.jpg';
import svgStories from '-!raw-loader!../../images/pages/menu/stories.svg';

import imgResume from '../../images/pages/menu/resume.jpg';
import svgResume from '-!raw-loader!../../images/pages/menu/resume.svg';

import imgPortfolio from '../../images/pages/menu/portfolio.jpg';
import svgPortfolio from '-!raw-loader!../../images/pages/menu/portfolio.svg';

import imgPhotography from '../../images/pages/menu/photography.jpg';
import svgPhotography from '-!raw-loader!../../images/pages/menu/photography.svg';
/* eslint-enable import/no-webpack-loader-syntax */

// Project Image Import
/* eslint-disable import/no-webpack-loader-syntax */
import mercuryzoneLogo from '../../images/pages/porfolio/mercuryzone/mercuryzone--logo.svg';
import mercuryzoneBackground from '../../images/pages/porfolio/mercuryzone/mercuryzone--background.jpg';
import mercuryzoneMain from '../../images/pages/porfolio/mercuryzone/mercuryzone--main.jpg';
import mercuryzoneBackgroundSVG from '-!raw-loader!../../images/pages/porfolio/mercuryzone/mercuryzone--background.svg';

import fleetprocureLogo from '../../images/pages/porfolio/fleetprocure/fleetprocure--logo.svg';
import fleetprocureBackground from '../../images/pages/porfolio/fleetprocure/fleetprocure--background.jpg';
import fleetprocureMain from '../../images/pages/porfolio/fleetprocure/fleetprocure--main.jpg';
import fleetprocureBackgroundSVG from '-!raw-loader!../../images/pages/porfolio/fleetprocure/fleetprocure--background.svg';

import triporgLogo from '../../images/pages/porfolio/triporg/triporg--logo.png';
import triporgBackground from '../../images/pages/porfolio/triporg/triporg--background.jpg';
import triporgMain from '../../images/pages/porfolio/triporg/triporg--main.jpg';
import triporgBackgroundSVG from '-!raw-loader!../../images/pages/porfolio/triporg/triporg--background.svg';

import yellowmachineLogo from '../../images/pages/porfolio/yellowmachine/yellowmachine--logo.png';
import yellowmachineBackground from '../../images/pages/porfolio/yellowmachine/yellowmachine--background.jpg';
import yellowmachineMain from '../../images/pages/porfolio/yellowmachine/yellowmachine--main.jpg';
import yellowmachineBackgroundSVG from '-!raw-loader!../../images/pages/porfolio/yellowmachine/yellowmachine--background.svg';

import knowlliiLogo from '../../images/pages/porfolio/knowlii/knowlii--logo.png';
import knowlliiBackground from '../../images/pages/porfolio/knowlii/knowlii--background.jpg';
import knowlliiMain from '../../images/pages/porfolio/knowlii/knowlii--main.jpg';
import knowliiBackgroundSVG from '-!raw-loader!../../images/pages/porfolio/knowlii/knowlii--background.svg';

import indexacapitaLogo from '../../images/pages/porfolio/indexacapital/indexacapital--logo.svg';
import indexacapitaBackground from '../../images/pages/porfolio/indexacapital/indexacapital--background.jpg';
import indexacapitalMain from '../../images/pages/porfolio/indexacapital/indexacapital--main.jpg';
import indexacapitalBackgroundSVG from '-!raw-loader!../../images/pages/porfolio/indexacapital/indexacapital--background.svg';

import dudumfinancialLogo from '../../images/pages/porfolio/dudumfinancial/dudumfinancial--logo.svg';
import dudumfinancialBackground from '../../images/pages/porfolio/dudumfinancial/dudumfinancial--background.jpg';
import dudumfinancialMain from '../../images/pages/porfolio/dudumfinancial/dudumfinancial--main.jpg';
import dudumfinancialBackgroundSVG from '-!raw-loader!../../images/pages/porfolio/dudumfinancial/dudumfinancial--background.svg';
/* eslint-enable import/no-webpack-loader-syntax */

export const contactNetworks = [
  {
    network: 'Linkedin',
    url: 'https://www.linkedin.com/in/andermurias/',
    icon: 'fa-linkedin'
  },
  {
    network: 'Twitter',
    url: 'https://twitter.com/andermurias',
    icon: 'fa-twitter'
  },
  {
    network: 'Facebook',
    url: 'https://www.facebook.com/andermurias',
    icon: 'fa-facebook'
  },
  {
    network: 'Instagram',
    url: 'https://www.instagram.com/andermurias/',
    icon: 'fa-instagram'
  },
  {
    network: '500px',
    url: 'https://www.500px.com/andermurias',
    icon: 'fa-500px'
  }
];

export const Pages = [
  {
    name: "About",
    img: imgAbout,
    svg: svgAbout,
    subtitle: 'Who I am, Who I was and Who I want to be',
    url: "/about",
    content: [
      {
        title: 'Hey! It\'s me, Ander',
        content: (
          <div>
          <p>
              I'm a Dream Maker & Software Developer, which means that I thrive on turning ideas into projects. I enjoy creating amazing software experiences based on design, interaction and innovation.
          </p>
            <p>
            As a brief summary: I've been working in startups, and I’ve had my own. I've being self-employed, and now I'm a partner and project manager at <b>Yellow Machine Studio/Koalition</b> in Bilbao.
          </p>
          </div>
        )
      },
      {
        title: 'Dream Maker',
        content: (
          <div>
            <p>
              <b>Why Dream Maker?</b> Well, a lot of people can create a site, an app or even a huge service with a lot of complicated backend and frontcend stuff, but what I really like to do is understand a dream and turn it into a reality.
            </p>
            <p>
               I've worked on a lot of projects for others and several of my own, and all that experience has helped me to develop an understanding of how to attend to the needs and expectations of a variety of clients.
            </p>
          </div>
        )
      },
      {
        title: 'Afterwork',
        content: (
          <div>
            <p>
                I really enjoy my job, but life is not only work. Everyone has hobbies, and I'm no different.
            </p>
            <p>
                I really enjoy <b>music</b>. Whether helping me focus at work or just relax, music is always with me. I love discovering new bands or songs that I haven’t experienced yet.
            </p>
            <p>
              I'm also an amateur <b>photographer</b>. Whenever I have the opportunity, I always take my camera along to shoot some pictures.
            </p>
            <p>
              If you want to <b>check out my photos</b> or the <b>music I'm listening right now</b>, here are my profiles:
            </p>
            <NetworkList className="network-list--dark network-list--left" networks={[
              {
                network: 'Instagram',
                url: 'https://www.instagram.com/andermurias/',
                icon: 'fa-instagram'
              },
              {
                network: '500px',
                url: 'https://www.500px.com/andermurias',
                icon: 'fa-500px'
              },
              {
                network: 'Spotify',
                url: 'https://open.spotify.com/user/dreamcacher',
                icon: 'fa-spotify'
              }
            ]}/>
          </div>
        )
      },
    ]
  },
  {
    name: (<span>Port<wbr/>folio</span>),
    img: imgPortfolio,
    svg: svgPortfolio,
    subtitle: 'What I\'ve done',
    url: "/portfolio",
    content: [
      {
        title: 'This is my work',
        content: (
          <div>
            <p>
              Every project has a catch or a unique set of difficulties, but what I really like is that feeling when a job is done and I can feel proud of the result.
            </p>
            <p>
                Although I try to make every work special, there are some projects for which I have special affection, such as <b>Mercuryzone</b>, an idea that started a few years ago and, ultimately, helped me to evolve a lot as a person and an entrepreneur.
            </p>
            <p>
              Here is a brief selection of <b>some of my best works, including those I’ve completed</b> as an employee and as a freelancer or consultant.
            </p>
          </div>
        )
      }
    ]
  }
  ,
  {
    name: "Resume",
    img: imgResume,
    svg: svgResume,
    subtitle: 'What I do, and what I can do',
    url: "/resume",
    content: [
      {
        title: 'Not just frontend',
        content: (
          <div>
            <p>
              I must admit that time puts everyone in his place, and for a time, it put me as a <b>web developer, specialized in frontend development</b>, but that's not the only thing I can do.
            </p>
            <p>
              I'm a <b>full-stack developer</b>, and I’ve also worked in <b>backend development</b> a lot, creating services and APIs, all of them based on PHP with Symfony and Yii2.

            </p>
            <p>
              But this is only some of what can I do. <b>Want to know more? Continue below</b>.
            </p>
          </div>
        )
      },
      {
        title: (<span>What <span className="red">can</span> I do</span>),
        content: (
          <div>
            <ResumeList className="resume-list--left" title="Mobile development"
                        elements={['Android/Java', 'iOS/Swift', 'Ionic', 'Apache Cordova']}/>
            <ResumeList className="resume-list--left" title="Web Development"
                        elements={['PHP 7+', 'Javascript/ES6', 'Symfony', 'Yii 2', 'Typescript', 'AngularJS & Angular 2', 'React', 'CSS3/Sass', 'SQL', 'Email Template']}/>
            <ResumeList className="resume-list--left" title="Others"
                        elements={['Git & Subversion', 'DevOps', 'Photoshop', 'Ilustrator']}/>
          </div>
        )
      }, {
        title: (<span>What I <span className="red">do</span> daily</span>),
        content: (
          <div>
            <p>
              In the last few years I've done many things, including frontend, backend, app development, but the field where I feel most at home is <b>web development</b>. Working with PHP and Javascript allows me to create extraordinary projects.
            </p>
            <p>
              In <b>frontend development</b>, I work with frameworks/libraries like <b>Angular</b> and <b>React</b>, combined with CSS3 and Sass, to achieve astounding results.
            </p>
            <p>
            In <b>backend development</b>, I use <b>PHP 7+</b> as a primary language with <b>Yii 2</b> and <b>Symfony</b> as frameworks and <b>Node.js</b> with <b>Socket.io</b> and <b>Express</b> when required.
            </p>
            <p>
              In all these fields, I focus on using the best tools to obtain the best performance possible with a strong base that allows me to keep my attention on what matters most: <b>the result</b>.
            </p>
          </div>
        )
      }, {
        title: (<span>Where I've <span className="red">been</span> working</span>),
        content: (
          <div>
            <ResumeJobs elements={[
              {
                title: (
                  <a href='https://www.koalition.com' target="_blank" rel="noopener noreferrer">Yellow Machine Studio /
                                                                                                Koalition</a>),
                date: '2016 - Actually',
                charge: 'Partner',
                description: 'Yellow Machines Studio / Koalition is a software agency focused on creative and interactive results.'
              },
              {
                title: 'Freelancer',
                date: '2014 - 2016',
                charge: 'Full-Stack Developer',
                description: 'As a freelancer, I worked as a frontend developer mainly focused on CMS-based websites.'
              },
              {
                title: (
                  <a href='https://www.mercuryzone.net' target="_blank" rel="noopener noreferrer">Mercuryzone</a>),
                date: '2014 - 2016',
                charge: 'CEO',
                description: 'Mercuryzone is a messaging service that focuses on only showing you the messages that are relevant to you based on a social validation method.'
              },
              {
                title: (<a href='https://www.triporg.org' target="_blank" rel="noopener noreferrer">Triporg</a>),
                date: '2012 - 2014',
                charge: 'Full-Stack Developer',
                description: 'Triporg is a full-trip organizer that takes what you like to do and see and generates the best plan for you every day that you are in a city.'
              },
            ]}/>
          </div>
        )
      }
    ]
  }
  ,
  {
    name: (<span>Photo<wbr/>graphy</span>),
    img: imgPhotography,
    svg: svgPhotography,
    subtitle: 'What I see',
    url: "/photography",
    content: [
      {
        title: 'One more shoot',
        content: (
          <div>
            <p>
              To be honest, I didn't care about photography until a few years ago. It’s not that I didn't like it; I just didn’t know anything about it.
            </p>
            <p>
              It all started with a rather funny eBay encounter. I found myself bidding on a relatively cheap and heavily used camera, all along thinking <i>“I’m placing such low bids, I’ll never win the auction.”</i> But it turns out that maybe no one else was paying attention to it at all. And so I found myself with a new toy, taking quite a few not-so-good shots.
            </p>
            <p>
              It’s been a few years since that fateful bid, and I don’t regret it a bit. I discovered a great new hobby and passion and a new way <b>to share my point of view</b>.
            </p>
          </div>
        )
      },
      {
        content: (
          <div>
            <p>
              These are only a few selections from my photography collection. <b>Did you like them? Do you want to see more?</b> Here are my photography social networks:
            </p>
            <NetworkList className="network-list--dark network-list--center" networks={[
              {
                network: 'Instagram',
                url: 'https://www.instagram.com/andermurias/',
                icon: 'fa-instagram'
              },
              {
                network: '500px',
                url: 'https://www.500px.com/andermurias',
                icon: 'fa-500px'
              },
              {
                network: 'Flickr',
                url: 'https://www.flickr.com/photos/andermurias/',
                icon: 'fa-flickr'
              }
            ]}/>
          </div>
        )
      },
    ]
  }
  ,
  {
    name: "Stories",
    img: imgStories,
    svg: svgStories,
    url: "https://stories.andermurias.me"
  }
  ,
  {
    name: "Contact",
    img: imgContact,
    svg: svgContact,
    subtitle: 'Where I am',
    url: "/contact",
    content: [
      {
        title: 'Say Hi!',
        content: (
          <div>
            <p>
            </p>
            <p>
              <b>Do you like my work, have any idea, or just want to say hi?</b> If you want to contact me, here are the social networks I use the most.
            </p>
            <NetworkList networks={contactNetworks}
                         className="network-list--left network-list--dark network-list--inline"/>
            <p>
              If you prefer emails and want to send me one, my email address is <a href="mailto:ander@murias.nl">ander@murias.nl</a>, or we can chat via Skype, where my username is <a href="skype:andermues?userinfo">@andermues</a>.
            </p>
            <p>
              <b>Would you prefer to come to my office?</b> Here is the address:
            </p>
          </div>
        )

      },
    ]
  }
];

export const Projects = [
  {
    name: 'Dudum Financial',
    slug: 'dudum-financial',
    img: dudumfinancialBackground,
    logo: dudumfinancialLogo,
    url: 'http://www.dudumfinancial.com/',
    images: {
      main: dudumfinancialMain,
      background: dudumfinancialBackgroundSVG
    },
    gradient: 'shark',
    tags: ['PHP', 'Frontend', 'Javascript', 'Wordpress'],
    relation: 'Consultant',
    client: 'Koalition',
    role: 'Software Developer',
    description: (
      <div>
        <p>
        Dudum Financial has been the leader in employee benefits and retirement plans for the golf and private club industry for over a decade.
        </p>
        <p>
        Our innovative, unique and proprietary programs provide enriched benefit offerings to some of the most prestigious golf and private clubs in the United States, along with world-renowned yacht, equestrian, athletic and business clubs. Servicing over 200 golf and private clubs throughout the nation, our team of experts works closely with our clients to create a forward-thinking strategy that will add value to your long-term planning.
        </p>
        <p>
        Dudum Financial is recognized as the unmatched leader in the implementation and administration of world-class employee benefit platforms.
        </p>

      </div>
    )
  }, {
    name: 'Indexa Capital',
    slug: 'indexa-capital',
    img: indexacapitaBackground,
    logo: indexacapitaLogo,
    url: 'https://indexacapital.com/es',
    images: {
      main: indexacapitalMain,
      background: indexacapitalBackgroundSVG
    },
    gradient: 'red',
    tags: ['App', 'Cordova', 'Angular', 'Ionic'],
    relation: 'Consultant',
    role: 'App Developer',
    description: (
      <div>
        <p>
         Indexa Capital is the leading automated manager in Spain. It offers discretionary management of portfolios, indexed funds or indexed pension plans, with global diversification and the lowest commissions in the market. Less costs, more profitability.
        </p>
      </div>
    )
  }, {
    name: 'Fleet Procure',
    slug: 'fleet-procure',
    img: fleetprocureBackground,
    logo: fleetprocureLogo,
    url: 'http://www.fleetprocure.com/',
    images: {
      main: fleetprocureMain,
      background: fleetprocureBackgroundSVG
    },
    gradient: 'shark',
    tags: ['PHP', 'Frontend', 'Backend', 'Yii2'],
    relation: 'Consultant',
    client: 'Yellow Machine Studio',
    role: 'Software Developer',
    description: (
      <div>
        <p>
        Fleet Procure is a provider of web-based software solutions that connect the automotive industry to vehicle leasing companies through an innovative e-procurement platform.
        </p>
        <p>
        This purpose-built platform has been developed to provide a fast route to market for car dealers looking to engage with vehicle leasing companies, encompassing all aspects of the procurement process from initial quotation all the way through to delivery and payout.
        </p>
        <p>
        For vehicle leasing companies, the platform gives them instant access to over 100 fleet-focused dealerships that provide competitive pricing and availability, while ensuring high levels of service throughout the transaction process.
        </p>
      </div>
    )
  }, {
    name: 'Knowlii',
    slug: 'knowlii',
    img: knowlliiBackground,
    logo: knowlliiLogo,
    url: 'https://www.knowlii.com/',
    images: {
      main: knowlliiMain,
      background: knowliiBackgroundSVG
    },
    gradient: 'orange',
    tags: ['Frontend', 'Angular', 'Symfony'],
    relation: 'Consultant',
    role: 'Frontend Developer',
    description: (
      <div>
        <p>
        Knowlii is a travel app that uses technology to connect people. It connects users to local experts, live, enabling local knowledge to be exchanged between people in real-time and helping you ﬁnd where to go.
        </p>
        <p>
        How does it work?
        </p>
        <p>
        Ever been in a city for the ﬁrst time and wished you had a friend there? Knowlii uses technology to connect you to local experts. Simply send out your request and ask where to go.
        </p>
      </div>
    )
  }, {
    name: 'Triporg',
    slug: 'triporg',
    img: triporgBackground,
    logo: triporgLogo,
    url: 'https://www.triporg.org/',
    images: {
      main: triporgMain,
      background: triporgBackgroundSVG
    },
    gradient: 'green',
    tags: ['Frontend', 'Backend', 'API', 'Symfony'],
    relation: 'Worker',
    role: 'Software Developer',
    description: (
      <div>
        <p>
        Triporg is the online trip planner that works in seconds to help you select what to see and what to do in the city you choose, according to your likes and preferences.
        </p>
        <p>
        It also takes into account the opening hours of the different tourist attractions, the time needed to enjoy an activity and the time needed to move from one activity to the following one. You also have the possibility of booking a hotel/hostel and buying your tickets in advance, avoiding those boring and endless queues.
        </p>
        <p>
        It creates your travel plan and takes into account the location of the place you are staying and the commitments you might have during your travel, making it an ideal option for business people and business travel.
        </p>
      </div>)
  }, {
    name: 'Yellow Machine Studio',
    slug: 'yellow-machine-studio',
    img: yellowmachineBackground,
    logo: yellowmachineLogo,
    url: 'http://www.koalition.com/',
    images: {
      main: yellowmachineMain,
      background: yellowmachineBackgroundSVG
    },
    tags: ['Project Manager', 'Software Development', 'Agile'],
    relation: 'Partner',
    role: 'Project Manager',
    description: (
      <div>
        <p>
        Yellow Machine Studio is a software development company specializing in web development, focusing mainly on interactive pages with highly visual designs and marketing campaigns.
        </p>
        <p>
        At the same time, we are also dedicated to the development of online services with technologies such as Node.js or PHP and cross-platform applications.
        </p>
        <p>
        We like to work on our developments in detail and achieve the best possible results. Thanks to that we have worked with some well-known companies worldwide, such as Nars, Red Bull, Getty and Vice, among others.
        </p>
      </div>
    )
  }, {
    name: 'Mercuryzone',
    slug: 'mercuryzone',
    img: mercuryzoneBackground,
    logo: mercuryzoneLogo,
    url: '',
    images: {
      main: mercuryzoneMain,
      background: mercuryzoneBackgroundSVG
    },
    gradient: 'blue',
    tags: ['CEO', 'Frontend', 'Backend', 'iOS', 'Android'],
    relation: 'Owner',
    role: 'CEO',
    description: (
      <div>
        <p>
        Mercuryzone is the online messaging service for groups that notifies you of relevant messages in a simple and structured way. Its ease-of-use feature divides information into two levels: relevant messages, which users are notified of, and secondary messages, which remain in the background.
        </p>
        <p>
        Users receive featured messages because the administrator either writes them or approves them based on their deemed importance to the people in the group. Furthermore, it adapts to the needs of each user and group. Mercuryzone can be used on any digital device from a computer to a mobile phone, making it an ideal tool for communication in classes, teams, working groups or even for events.
        </p>
        <p>
        To avoid wasting your time, Mercuryzone notifies you when something important happens.
        </p>
      </div>
    )
  },
];


export const mapStyle = [
  {
    "featureType": "all",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#2d3135"
      }
    ]
  },
  {
    "featureType": "all",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#c7c3bf"
      },
      {
        "lightness": "0"
      }
    ]
  },
  {
    "featureType": "all",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#272a2e"
      },
      {
        "gamma": "1.00"
      },
      {
        "lightness": "-30"
      }
    ]
  },
  {
    "featureType": "all",
    "elementType": "labels.icon",
    "stylers": [
      {
        "saturation": "-100"
      },
      {
        "lightness": "0"
      },
      {
        "gamma": "1.00"
      },
      {
        "invert_lightness": true
      },
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#272a2e"
      },
      {
        "lightness": "10"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#272a2e"
      },
      {
        "lightness": "10"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#272a2e"
      }
    ]
  }
];


/*
 BASED ON 500px API Using this function
 var b = [];
 a.map(function (e, i) {
 b[i] = {};
 b[i].name = e.name;
 b[i].img = {};
 b[i].img.s3 = e.images[0].url;
 b[i].img.s20 = e.images[1].url;
 b[i].img.s440 = e.images[2].url;
 b[i].url = 'https://500px.com'+e.url;
 });
 JSON.stringify(b);
 */


export const Photos = [
  {
    "name": "Vitoria church",
    "img": {
      "s3": "https://drscdn.500px.org/photo/210216453/w%3D280_h%3D280/ad603006db3240e32f57fa6f59f5c14a?v=0",
      "s20": "https://drscdn.500px.org/photo/210216453/h%3D300/54b1b818cd70c4e6c8c85de743277409",
      "s440": "https://drscdn.500px.org/photo/210216453/w%3D440_h%3D440/5c0a87e006ab8c2dec877c99b403a0d5?v=0"
    },
    "url": "https://500px.com/photo/210216453/vitoria-church-by-ander-murias"
  }, {
    "name": "Guggenheim corner",
    "img": {
      "s3": "https://drscdn.500px.org/photo/210059475/w%3D280_h%3D280/094b5b2292b9a8d056040b832b707b0e?v=0",
      "s20": "https://drscdn.500px.org/photo/210059475/h%3D300/abc6896760ad532510807b8b028950ea",
      "s440": "https://drscdn.500px.org/photo/210059475/w%3D440_h%3D440/260f76673ea6fa0d2b5d36628b3657b3?v=0"
    },
    "url": "https://500px.com/photo/210059475/guggenheim-corner-by-ander-murias"
  }, {
    "name": "House painted in vitoria",
    "img": {
      "s3": "https://drscdn.500px.org/photo/209913931/w%3D280_h%3D280/28647a9a9e5da1dbb097ee570f3d1fa8?v=0",
      "s20": "https://drscdn.500px.org/photo/209913931/h%3D300/c1d751b53e7101210c53cff0c5d078f4",
      "s440": "https://drscdn.500px.org/photo/209913931/w%3D440_h%3D440/3fe99174bb159256d3602259e993f153?v=0"
    },
    "url": "https://500px.com/photo/209913931/house-painted-in-vitoria-by-ander-murias"
  }, {
    "name": "Alone in the street",
    "img": {
      "s3": "https://drscdn.500px.org/photo/209781945/w%3D280_h%3D280/23abdb4d0f2d65ed78dbd7c008c12f71?v=0",
      "s20": "https://drscdn.500px.org/photo/209781945/h%3D300/bd6bd49514f1b127c6841228954e09f4",
      "s440": "https://drscdn.500px.org/photo/209781945/w%3D440_h%3D440/d42f707bf8f257be2f0e8e05111c6b92?v=0"
    },
    "url": "https://500px.com/photo/209781945/alone-in-the-street-by-ander-murias"
  }, {
    "name": "Vitoria cathedral",
    "img": {
      "s3": "https://drscdn.500px.org/photo/209658569/w%3D280_h%3D280/2145d0c71fd2d604724c229288bf6469?v=0",
      "s20": "https://drscdn.500px.org/photo/209658569/h%3D300/09ce8e9fa2fbce1399ef2513ecf73101",
      "s440": "https://drscdn.500px.org/photo/209658569/w%3D440_h%3D440/939428fdb2f6f88351a592ab0c72f75f?v=0"
    },
    "url": "https://500px.com/photo/209658569/vitoria-cathedral-by-ander-murias"
  }, {
    "name": "Guggenheim from La salve",
    "img": {
      "s3": "https://drscdn.500px.org/photo/209534273/w%3D280_h%3D280/5f4b9f19eac20734a7092eeab2866a2b?v=0",
      "s20": "https://drscdn.500px.org/photo/209534273/h%3D300/4ec355c77f073c1e390efa2c9479a571",
      "s440": "https://drscdn.500px.org/photo/209534273/w%3D440_h%3D440/d2859c774bc5514ec96313001a9af076?v=0"
    },
    "url": "https://500px.com/photo/209534273/guggenheim-from-la-salve-by-ander-murias"
  }, {
    "name": "Love Of lesbian",
    "img": {
      "s3": "https://drscdn.500px.org/photo/209401945/w%3D280_h%3D280/9f90577d5782b1862831014edb5c2194?v=0",
      "s20": "https://drscdn.500px.org/photo/209401945/h%3D300/ca759cc3d05e1699fc2e6e0a5636db0f",
      "s440": "https://drscdn.500px.org/photo/209401945/w%3D440_h%3D440/2883e4d13e69e719c786050410f210ee?v=0"
    },
    "url": "https://500px.com/photo/209401945/love-of-lesbian-by-ander-murias"
  }, {
    "name": "La salve",
    "img": {
      "s3": "https://drscdn.500px.org/photo/209254603/w%3D280_h%3D280/ddc2d8cbbc9f6c99eeffcf6a8e3141b8?v=0",
      "s20": "https://drscdn.500px.org/photo/209254603/h%3D300/3d92771d0253b74c22e61acd58c54410",
      "s440": "https://drscdn.500px.org/photo/209254603/w%3D440_h%3D440/c549944f8cacb21517cbb6c63e221836?v=0"
    },
    "url": "https://500px.com/photo/209254603/la-salve-by-ander-murias"
  }, {
    "name": "Mama",
    "img": {
      "s3": "https://drscdn.500px.org/photo/209107245/w%3D280_h%3D280/74282e80c69778059c8116c43b7e7a07?v=0",
      "s20": "https://drscdn.500px.org/photo/209107245/h%3D300/c2d9d8acce595e08279d66f34b04d960",
      "s440": "https://drscdn.500px.org/photo/209107245/w%3D440_h%3D440/c0c72d595bf9c4afb340bb59d749a00e?v=0"
    },
    "url": "https://500px.com/photo/209107245/mama-by-ander-murias"
  }, {
    "name": "Santo Tomás",
    "img": {
      "s3": "https://drscdn.500px.org/photo/208959647/w%3D280_h%3D280/c6c951646030df6249815c73df9dbc82?v=0",
      "s20": "https://drscdn.500px.org/photo/208959647/h%3D300/d223097755db5748167c178fab394247",
      "s440": "https://drscdn.500px.org/photo/208959647/w%3D440_h%3D440/84d60096c66029890a044a49c60f0d4d?v=0"
    },
    "url": "https://500px.com/photo/208959647/santo-tom%C3%A1s-by-ander-murias"
  }, {
    "name": "Vitoria Cathedral",
    "img": {
      "s3": "https://drscdn.500px.org/photo/208815041/w%3D280_h%3D280/9c041f542ab85610d7806b6e3b84108c?v=0",
      "s20": "https://drscdn.500px.org/photo/208815041/h%3D300/bbea30088438b17ce9615be60ef9180f",
      "s440": "https://drscdn.500px.org/photo/208815041/w%3D440_h%3D440/baace8af8d369ac793fe409f80f95613?v=0"
    },
    "url": "https://500px.com/photo/208815041/vitoria-cathedral-by-ander-murias"
  }, {
    "name": "Love Of Lesbian",
    "img": {
      "s3": "https://drscdn.500px.org/photo/208683341/w%3D280_h%3D280/855b07fdb92b191a26e1ca8434b6441b?v=0",
      "s20": "https://drscdn.500px.org/photo/208683341/h%3D300/b1ca99e047e5a24aaf4cbc81b431e558",
      "s440": "https://drscdn.500px.org/photo/208683341/w%3D440_h%3D440/8299aa168d468ee43a0cae5f21859ff2?v=0"
    },
    "url": "https://500px.com/photo/208683341/love-of-lesbian-by-ander-murias"
  }, {
    "name": "Painting in Vitoria",
    "img": {
      "s3": "https://drscdn.500px.org/photo/208549381/w%3D280_h%3D280/0598e6fb34096b7884c518e44a4821f7?v=0",
      "s20": "https://drscdn.500px.org/photo/208549381/h%3D300/b5f8e9b5629ddf330214fb44144d8486",
      "s440": "https://drscdn.500px.org/photo/208549381/w%3D440_h%3D440/76360eec875ab2732798b1fbbdab0101?v=0"
    },
    "url": "https://500px.com/photo/208549381/painting-in-vitoria-by-ander-murias"
  }, {
    "name": "Street Painting",
    "img": {
      "s3": "https://drscdn.500px.org/photo/208407579/w%3D280_h%3D280/9333097655225006110b2d1851da9267?v=0",
      "s20": "https://drscdn.500px.org/photo/208407579/h%3D300/bed486fdf782e9f2991d3c30dfd176cb",
      "s440": "https://drscdn.500px.org/photo/208407579/w%3D440_h%3D440/b37aeac6164f8cc98924170916f2d817?v=0"
    },
    "url": "https://500px.com/photo/208407579/street-painting-by-ander-murias"
  }, {
    "name": "Arriaga Theater",
    "img": {
      "s3": "https://drscdn.500px.org/photo/189836663/w%3D280_h%3D280/3df440dc73199d9ffa3fad9445173973?v=2",
      "s20": "https://drscdn.500px.org/photo/189836663/h%3D300/cc98f3c2694049e2cefe1b4771493277",
      "s440": "https://drscdn.500px.org/photo/189836663/w%3D440_h%3D440/10d238502aba1fac82ca0e2d232164b5?v=2"
    },
    "url": "https://500px.com/photo/189836663/arriaga-theater-by-ander-murias"
  }, {
    "name": "4th Street",
    "img": {
      "s3": "https://drscdn.500px.org/photo/189015061/w%3D280_h%3D280/41730cefa1f479982e14b01d977a8d24?v=3",
      "s20": "https://drscdn.500px.org/photo/189015061/h%3D300/f087c7bdc64ba85543acbcaadf6799cd",
      "s440": "https://drscdn.500px.org/photo/189015061/w%3D440_h%3D440/ac378d135d2bf0a237a4a11b4d6a5dc0?v=3"
    },
    "url": "https://500px.com/photo/189015061/4th-street-by-ander-murias"
  }, {
    "name": "Glass of Coke",
    "img": {
      "s3": "https://drscdn.500px.org/photo/189015057/w%3D280_h%3D280/75cdfbdc01f28de625756e393bde8373?v=3",
      "s20": "https://drscdn.500px.org/photo/189015057/h%3D300/f9128695c270283106f8b32f472db28f",
      "s440": "https://drscdn.500px.org/photo/189015057/w%3D440_h%3D440/608bb2a26dc829e39d65d0102c08e711?v=3"
    },
    "url": "https://500px.com/photo/189015057/glass-of-coke-by-ander-murias"
  }, {
    "name": "Fountain shadow",
    "img": {
      "s3": "https://drscdn.500px.org/photo/186562269/w%3D280_h%3D280/d46ab4c829fc8fc470e449aa08bc4227?v=3",
      "s20": "https://drscdn.500px.org/photo/186562269/h%3D300/25706ba3c9827a93867f9bf2f2ee1b9d",
      "s440": "https://drscdn.500px.org/photo/186562269/w%3D440_h%3D440/717b14eb0920e1180a8b5eefd3842484?v=3"
    },
    "url": "https://500px.com/photo/186562269/fountain-shadow-by-ander-murias"
  }, {
    "name": "Road Arrow",
    "img": {
      "s3": "https://drscdn.500px.org/photo/186562267/w%3D280_h%3D280/9eaf27f545eb55bcbb7d38de2e80d8c5?v=3",
      "s20": "https://drscdn.500px.org/photo/186562267/h%3D300/7baa8e748dc4527af40afe6bbe1ed45c",
      "s440": "https://drscdn.500px.org/photo/186562267/w%3D440_h%3D440/5ee0e98b1fb6ef5f472f0681cccf4d6b?v=3"
    },
    "url": "https://500px.com/photo/186562267/road-arrow-by-ander-murias"
  }, {
    "name": "Car Lights",
    "img": {
      "s3": "https://drscdn.500px.org/photo/175717525/w%3D280_h%3D280/352daa93d45f9be225a05adcd1afb0ed?v=3",
      "s20": "https://drscdn.500px.org/photo/175717525/h%3D300/7674701207e765a4f0e549ec7a2ef477",
      "s440": "https://drscdn.500px.org/photo/175717525/w%3D440_h%3D440/8d45843e5bb0603ae3fec9bc3b0792d5?v=3"
    },
    "url": "https://500px.com/photo/175717525/car-lights-by-ander-murias"
  }
];


// WEBPACK FOOTER //
// ./src/js/common/vars.js